export default "__VITE_ASSET__DLE44fw0__"